export interface IDay {
    id: number,
    name: string
}